import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FormServiceFieldGeneralName, FormServiceFieldGeneralPurpose, FormServiceFieldGeneralStatus, FormServiceFieldGeneralProvider, FormServiceFieldGeneralProviderPrivacyPolicyUrl, FormServiceFieldGeneralProviderLegalNoticeUrl, FormServiceFieldGeneralGroup, FormServiceLayout, FormServiceFieldGeneralDataProcessingCountries, FormServiceFieldGeneralLegalBasis, FormServiceFieldGeneralDataProcessingCountriesSpecialTreatment, FormServiceFieldGeneralProviderContact } from "../..";
import { useI18n } from "../../../../../contexts";
import { FormHeadline } from "../../..";
import { LearnMoreTag } from "../../../../common";
const FormServiceFieldGeneralCompose = ()=>{
    const { __ } = useI18n();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(FormHeadline, {
                offset: FormServiceLayout.labelCol.span,
                children: [
                    __("General service configuration"),
                    " ",
                    /*#__PURE__*/ _jsx(LearnMoreTag, {
                        url: __("https://devowl.io/knowledge-base/real-cookie-banner-create-individual-cookie/")
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralName, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralStatus, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralGroup, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralProvider, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralProviderContact, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralPurpose, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralProviderPrivacyPolicyUrl, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralProviderLegalNoticeUrl, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralLegalBasis, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralDataProcessingCountries, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralDataProcessingCountriesSpecialTreatment, {})
        ]
    });
};
export { FormServiceFieldGeneralCompose };
